/**
 * Issue #174 — Shared LP constants.
 *
 * The marketing LP root (page.tsx), the /samples listing
 * (samples/page.tsx), and the LpFooter all reference these values
 * verbatim. Without this module they were duplicated 3× — a divergence
 * (e.g. someone updates the LP host but misses one file) would only
 * surface via E2E. Single source of truth here.
 */

export const planListHref = 'https://app.daigakus.com/pricing';
// テナント向けサービスの公開導線。LP の「ログインはこちら」は
// テナント管理者ログイン（/t/login）に向ける。/login は運営スタッフ専用の
// SUPER ADMIN ログインであり、公開ページからはリンクしない。
export const loginHref = 'https://app.daigakus.com/t/login';
export const trialSignupHref = 'https://app.daigakus.com/signup/checkout?plan=medium&cycle=monthly';
export const templatesHref = '/templates';
export const samplesHref = '/samples';
export const contactHref = '/contact';
